import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Next JS",
    "Gatsby JS",
    "Material UI",
    "ANT Desing",
    "Chakra UI",
    "Shadcn",
    "Firebase",
    "Redux Toolkit",
    "GraphQL",
    "Apollo Client",
    "TypeScript",
    "JavaScript",
    "HTML5",
    "CSS3",
    "SASS",
    "Tailwind CSS",
    "Performance Optimization",
    "Component-Driven Development",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Frontend Development</h3>
                    <p>With 5+ years of experience, I specialize in building fast, scalable, and user-focused web interfaces using React and Next.js. I've led frontend development for comprehensive tracking device portals with real-time GPS monitoring, built high-performance responsive UIs with seamless data visualization, and integrated RESTful APIs and WebSocket services for live updates. I've successfully managed teams of frontend developers in Agile environments, conducted code reviews, and delivered impactful products at Cloud Primero, Brandverse-Chikoo, 433 Football, and Atompoint.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;